import { __assign } from "tslib";
import { scaleBand } from 'd3-scale';
import { calculateRange, normalizeDate } from '@keen.io/charts-utils';
import { calculateColorScale } from '../../../utils/colors.utils';
export var generateVerticalBlocks = function (_a) {
    var data = _a.data, keys = _a.keys, dimension = _a.dimension, margins = _a.margins, minValue = _a.minValue, maxValue = _a.maxValue, labelSelector = _a.labelSelector, colorMode = _a.colorMode, colors = _a.colors, steps = _a.steps, range = _a.range, yScaleSettings = _a.yScaleSettings;
    var _b = calculateRange(data, minValue, maxValue, keys), minimum = _b.minimum, maximum = _b.maximum;
    var scaleType = yScaleSettings.type, precision = yScaleSettings.precision;
    var dateNormalizer = scaleType === 'time' && precision
        ? function (date) { return normalizeDate(date, precision); }
        : null;
    var localizedData = dateNormalizer
        ? data.map(function (item) {
            var _a;
            return (__assign(__assign({}, item), (_a = {}, _a[labelSelector] = dateNormalizer(item[labelSelector]), _a)));
        })
        : data;
    var xScale = scaleBand()
        .range([margins.left, dimension.width - margins.right])
        .domain(keys.map(function (item) { return item; }));
    var yScale = scaleBand()
        .range([dimension.height - margins.bottom, margins.top])
        .domain(localizedData.map(function (item) { return item[labelSelector]; }));
    var color = calculateColorScale(minimum, maximum, colorMode, steps, colors);
    var blocks = [];
    keys.forEach(function (keyName, idx) {
        localizedData.forEach(function (_d, index) {
            var _a;
            var value = (_a = localizedData[index]) === null || _a === void 0 ? void 0 : _a[keyName];
            var inRange = range ? value >= range.min && value <= range.max : true;
            if (keyName !== labelSelector && inRange) {
                var block = {
                    key: index + "." + keyName + ".block",
                    selector: [index, keyName],
                    x: xScale(keyName),
                    y: yScale(_d[labelSelector]),
                    height: yScale.bandwidth(),
                    width: xScale.bandwidth(),
                    coordinates: [idx, index],
                    color: color(value),
                    value: value,
                };
                blocks.push(block);
            }
        });
    });
    return {
        blocks: blocks,
        xScale: xScale,
        yScale: yScale,
    };
};
export var generateHorizontalBlocks = function (_a) {
    var data = _a.data, keys = _a.keys, dimension = _a.dimension, margins = _a.margins, minValue = _a.minValue, maxValue = _a.maxValue, labelSelector = _a.labelSelector, colorMode = _a.colorMode, colors = _a.colors, steps = _a.steps, range = _a.range, yScaleSettings = _a.yScaleSettings;
    var _b = calculateRange(data, minValue, maxValue, keys), minimum = _b.minimum, maximum = _b.maximum;
    var scaleType = yScaleSettings.type, precision = yScaleSettings.precision;
    var dateNormalizer = scaleType === 'time' && precision
        ? function (date) { return normalizeDate(date, precision); }
        : null;
    var localizedData = dateNormalizer
        ? data.map(function (item) {
            var _a;
            return (__assign(__assign({}, item), (_a = {}, _a[labelSelector] = dateNormalizer(item[labelSelector]), _a)));
        })
        : data;
    var xScale = scaleBand()
        .range([margins.left, dimension.width - margins.right])
        .domain(localizedData.map(function (item) { return item[labelSelector]; }));
    var yScale = scaleBand()
        .range([dimension.height - margins.bottom, margins.top])
        .domain(keys.map(function (item) { return item; }));
    var color = calculateColorScale(minimum, maximum, colorMode, steps, colors);
    var blocks = [];
    keys.forEach(function (keyName, idx) {
        localizedData.forEach(function (_d, index) {
            var _a;
            var value = (_a = data[index]) === null || _a === void 0 ? void 0 : _a[keyName];
            var inRange = range ? value >= range.min && value <= range.max : true;
            if (keyName !== labelSelector && inRange) {
                var block = {
                    key: index + "." + keyName + ".block",
                    selector: [index, keyName],
                    x: xScale(_d[labelSelector]),
                    y: yScale(keyName),
                    height: yScale.bandwidth(),
                    width: xScale.bandwidth(),
                    color: color(value),
                    coordinates: [index, idx],
                    value: value,
                };
                blocks.push(block);
            }
        });
    });
    return {
        blocks: blocks,
        xScale: xScale,
        yScale: yScale,
    };
};
var BLOCK_RENDER_MAP = {
    vertical: generateVerticalBlocks,
    horizontal: generateHorizontalBlocks,
};
export var generateBlocks = function (options) {
    var layout = options.layout, xScaleSettings = options.xScaleSettings, yScaleSettings = options.yScaleSettings, xAxisTitle = options.xAxisTitle, yAxisTitle = options.yAxisTitle;
    var settings = layout === 'vertical'
        ? {
            xScaleSettings: xScaleSettings,
            yScaleSettings: yScaleSettings,
            xAxisTitle: xAxisTitle,
            yAxisTitle: yAxisTitle,
        }
        : {
            xScaleSettings: yScaleSettings,
            yScaleSettings: xScaleSettings,
            xAxisTitle: yAxisTitle,
            yAxisTitle: xAxisTitle,
        };
    return __assign({ settings: settings }, BLOCK_RENDER_MAP[layout].call(null, options));
};
